import "./settings.css";
import React, { useState, useEffect, useMemo } from "react";
import "reactjs-popup/dist/index.css";
import AppConstants from "../../../AppConstants";
import { Card, Container, Row, Col, Button } from "react-bootstrap";
import axios from "../../../../network/api";
import { getConfig } from "../../../../network/auth";
import { baseUrl } from "../../../../network/constants/constants";
import { MdOutlineFileUpload, MdClose } from "react-icons/md";
import TextField from "@mui/material/TextField";
import Popup from "reactjs-popup";
import Spinner from "../loader/loader";
import { RiImageEditLine } from "react-icons/ri";
import { Snackbar, Alert } from "@mui/material";

function Settings() {
  const [editPopupOpen, setEditPopupOpen] = useState(false);
  const [bannerPopupOpen, setBannerPopupOpen] = useState(false);
  const [logoPopupOpen, setLogoPopupOpen] = useState(false);
  const [thumbPopupOpen, setThumbPopupOpen] = useState(false);

  const [business, setBusiness] = useState([]);
  const [editedBusiness, setEditedBusiness] = useState({});
  const [loading, setLoading] = useState(false);

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedLogo, setSelectedLogo] = useState(null);
  const [selectedThumb, setSelectedThumb] = useState(null);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [bannerPreview, setBannerPreview] = useState(null);
  const [thumbPreview, setThumbPreview] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);

  let bID = localStorage.getItem(AppConstants.business_id);

  const config = useMemo(() => {
    return getConfig();
  }, []);

  // phone validation
  const validatePhoneNumber = (number) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(number);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let tempErrors = {};

    if (!validatePhoneNumber(editedBusiness.mobile_number)) {
      tempErrors.mobile_number = "Invalid phone number.";
    }

    if (Object.keys(tempErrors).length === 0) {
      setErrors({});
      handleEditBusiness();
    } else {
      setErrors(tempErrors);
    }
  };

  // fetch business details
  const fetchBusinessDetails = () => {
    setLoading(true);
    axios
      .get(`${baseUrl}app/business-details/${bID}/`, config)
      .then((response) => {
        const businessData = response.data;
        setBusiness(businessData ? [businessData] : []);
        setEditedBusiness({
          business_title: businessData.business_title,
          mobile_number: businessData.mobile_number,
          category_name: businessData.category_name,
          description: businessData.description,
          service_range_km: businessData.service_range_km,
          service_localities: businessData.service_localities,
          place: businessData.place,
          latitude: businessData.latitude,
          longitude: businessData.longitude,
        });
        setLoading(false);
      })
      .catch((error) => {
        console.error("Business Details Error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchBusinessDetails();
  }, []);

  const handleChangeBusiness = (event) => {
    const { name, value } = event.target;
    setEditedBusiness((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  // edit business details
  const handleEditBusiness = () => {
    setLoading(true);
    setSnackbarOpen(true);

    const payload = { ...editedBusiness };

    axios
      .patch(`${baseUrl}app/business/edit/${bID}/`, payload, config)
      .then((response) => {
        fetchBusinessDetails();
        setLoading(false);
        setEditPopupOpen(false);
        setSnackbarMessage(response.data.message);
      })
      .catch((error) => {
        console.error("Edit Business Error:", error);
        setLoading(false);
        setSnackbarMessage(
          error?.response?.data?.message ||
            error?.response?.data?.detail ||
            "Something went wrong"
        );
      });
  };

  // patch banner
  const handleBannerSubmit = () => {
    if (!selectedFile) return;
    setLoading(true);
    setSnackbarOpen(true);

    const formData = new FormData();
    formData.append("banner", selectedFile);

    axios
      .patch(`${baseUrl}app/business/edit/${bID}/`, formData, {
        headers: {
          ...config.headers,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        fetchBusinessDetails();
        setSelectedFile(null);
        setBannerPreview(null);
        setLoading(false);
        setBannerPopupOpen(false);
        setSnackbarMessage(response.data.message);
      })
      .catch((error) => {
        console.error("Banner Upload Error:", error);
        setLoading(false);
        setSnackbarMessage(error?.response?.data?.message || "Upload failed");
      });
  };

  const handleBannerFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    setBannerPreview(file ? URL.createObjectURL(file) : null);
  };

  // patch logo
  const handleLogoSubmit = () => {
    if (!selectedLogo) return;
    setLoading(true);
    setSnackbarOpen(true);

    const formData = new FormData();
    formData.append("logo", selectedLogo);

    axios
      .patch(`${baseUrl}app/business/edit/${bID}/`, formData, {
        headers: {
          ...config.headers,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        fetchBusinessDetails();
        setSelectedLogo(null);
        setLogoPreview(null);
        setLoading(false);
        setLogoPopupOpen(false);
        setSnackbarMessage(response.data.message);
      })
      .catch((error) => {
        console.error("Logo Upload Error:", error);
        setLoading(false);
        setSnackbarMessage(error?.response?.data?.message || "Upload failed");
      });
  };

  const handleLogoFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedLogo(file);
    setLogoPreview(file ? URL.createObjectURL(file) : null);
  };

  // patch thumb
  const handleThumbSubmit = () => {
    if (!selectedThumb) return;
    setLoading(true);
    setSnackbarOpen(true);

    const formData = new FormData();
    formData.append("thumb", selectedThumb);

    axios
      .patch(`${baseUrl}app/business/edit/${bID}/`, formData, {
        headers: {
          ...config.headers,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        fetchBusinessDetails();
        setSelectedThumb(null);
        setThumbPreview(null);
        setLoading(false);
        setThumbPopupOpen(false);
        setSnackbarMessage(response.data.message);
      })
      .catch((error) => {
        console.error("Thumb Upload Error:", error);
        setLoading(false);
        setSnackbarMessage(error?.response?.data?.message || "Upload failed");
      });
  };

  const handleThumbFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedThumb(file);
    setThumbPreview(file ? URL.createObjectURL(file) : null);
  };

  const handleSnackbarClose = () => {
    setSnackbarMessage(null);
  };

  return (
    <div className="main-div">
      {/* Banner Section */}
      <div className="mt-5 business-details-head">Banner</div>
      <Card className="business-card">
        {loading ? (
          <div className="loader-container">
            <Spinner />
          </div>
        ) : (
          <div className="add-banner-container">
            <Popup
              className="add-popup-container"
              contentStyle={{ borderRadius: "20px" }}
              trigger={
                <button
                  className="btn-add-banner"
                  onClick={() => setBannerPopupOpen(true)}
                >
                  + Change Banner
                </button>
              }
              modal
              nested
              open={bannerPopupOpen}
              onClose={() => setBannerPopupOpen(false)}
            >
              {(close) => (
                <div className="add-img-div">
                  <h3 className="add-img-heading">Change Banner Image</h3>
                  <form
                    method="post"
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleBannerSubmit();
                      close();
                    }}
                  >
                    <label className="add-file-upload">
                      <input
                        className="add-img-file"
                        id="file"
                        type="file"
                        onChange={handleBannerFileChange}
                      />
                      <MdOutlineFileUpload className="upload-icon" />
                      {selectedFile && (
                        <span className="file-name-label">
                          {selectedFile.name}
                        </span>
                      )}
                    </label>
                    {bannerPreview && (
                      <div className="image-preview">
                        <img
                          src={bannerPreview}
                          alt="Selected file preview"
                          style={{
                            maxWidth: "50%",
                            maxHeight: "100px",
                            marginTop: "10px",
                          }}
                        />
                      </div>
                    )}
                    <div className="submit-banner-file-container">
                      <button type="submit">Upload</button>
                      <button type="button" onClick={close}>
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </Popup>
          </div>
        )}
        {business.length === 0 ? (
          <p>No banner available to display.</p>
        ) : (
          <Row>
            {business.map((bDetails) => (
              <Col id={bDetails.id} key={bDetails.id} md={3} className="banner-item">
                <div className="banner-img-div">
                  <img
                    src={`${baseUrl}${bDetails.banner}`}
                    alt="banner"
                    className="banner-images img-fluid"
                  />
                </div>
              </Col>
            ))}
          </Row>
        )}
      </Card>

      {/* Thumb Section */}
      <div className="mt-5 business-details-head">Thumb</div>
      <Card className="business-card">
        {loading ? (
          <div className="loader-container">
            <Spinner />
          </div>
        ) : (
          <div className="add-banner-container">
            <Popup
              className="add-popup-container"
              contentStyle={{ borderRadius: "20px" }}
              trigger={
                <button
                  className="btn-add-banner"
                  onClick={() => setThumbPopupOpen(true)}
                >
                  + Change Thumb
                </button>
              }
              modal
              nested
              open={thumbPopupOpen}
              onClose={() => setThumbPopupOpen(false)}
            >
              {(close) => (
                <div className="add-img-div">
                  <h3 className="add-img-heading">Change Thumb Image</h3>
                  <form
                    method="post"
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleThumbSubmit();
                      close();
                    }}
                  >
                    <label className="add-file-upload">
                      <input
                        className="add-img-file"
                        id="file"
                        type="file"
                        onChange={handleThumbFileChange}
                      />
                      <MdOutlineFileUpload className="upload-icon" />
                      {selectedThumb && (
                        <span className="file-name-label">
                          {selectedThumb.name}
                        </span>
                      )}
                    </label>
                    {thumbPreview && (
                      <div className="image-preview">
                        <img
                          src={thumbPreview}
                          alt="Selected file preview"
                          style={{
                            maxWidth: "50%",
                            maxHeight: "100px",
                            marginTop: "10px",
                          }}
                        />
                      </div>
                    )}
                    <div className="submit-banner-file-container">
                      <button type="submit">Upload</button>
                      <button type="button" onClick={close}>
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </Popup>
          </div>
        )}
        {business.length === 0 ? (
          <p>No thumb available to display.</p>
        ) : (
          <Row>
            {business.map((bDetails) => (
              <Col key={bDetails.id} md={3} className="banner-item">
                <div className="thumb-img-div">
                  {bDetails?.plans?.[0]?.sub_plans?.[0]?.thumb ? (
                    <img
                      src={`${baseUrl}${bDetails.plans[0].sub_plans[0].thumb}`}
                      alt="thumb"
                      className="banner-images"
                    />
                  ) : (
                    <p>No thumb available.</p>
                  )}
                </div>
              </Col>
            ))}
          </Row>
        )}
      </Card>

      {/* Business Details */}
      <div className="business-details-map">
        {business.length === 0 ? (
          <p>No business details available to display.</p>
        ) : (
          business.map((bDetails) => (
            <React.Fragment key={bDetails.id}>
              <div className="mt-5 business-details-head">Business Details</div>
              <Card className="business-card">
                <Container className="business-row pb-3 pb-lg-4">
                  <div className="business_container">
                    <div className="logo-edit-container">
                      <img
                        className="business_image"
                        src={`${baseUrl}${bDetails.logo}`}
                        alt="Business"
                      />
                      <Popup
                        className="add-popup-container"
                        contentStyle={{ borderRadius: "20px" }}
                        trigger={<RiImageEditLine className="logo-edit" />}
                        modal
                        nested
                        open={logoPopupOpen}
                        onClose={() => setLogoPopupOpen(false)}
                      >
                        {(close) => (
                          <div className="add-img-div">
                            <h3 className="add-img-heading">Change Logo Image</h3>
                            <form
                              method="post"
                              onSubmit={(e) => {
                                e.preventDefault();
                                handleLogoSubmit();
                                close();
                              }}
                            >
                              <label className="add-file-upload">
                                <input
                                  className="add-img-file"
                                  id="file"
                                  type="file"
                                  onChange={handleLogoFileChange}
                                />
                                <MdOutlineFileUpload className="upload-icon" />
                                {selectedLogo && (
                                  <span className="file-name-label">
                                    {selectedLogo.name}
                                  </span>
                                )}
                              </label>
                              {logoPreview && (
                                <div className="image-preview">
                                  <img
                                    src={logoPreview}
                                    alt="Selected file preview"
                                    style={{
                                      maxWidth: "50%",
                                      maxHeight: "100px",
                                      marginTop: "10px",
                                    }}
                                  />
                                </div>
                              )}
                              <div className="submit-banner-file-container">
                                <button type="submit">Upload</button>
                                <button type="button" onClick={close}>
                                  Cancel
                                </button>
                              </div>
                            </form>
                          </div>
                        )}
                      </Popup>
                    </div>
                    <div className="business_details">
                      <div className="business_name">
                        {bDetails.business_title}
                      </div>
                      <div className="phone_number">{bDetails.mobile_number}</div>
                    </div>
                  </div>
                  <Button
                    className="edit-btn d-lg-block"
                    variant="success"
                    onClick={() => setEditPopupOpen(true)}
                  >
                    Edit
                  </Button>
                </Container>

                <Container>
                  <Row>
                    <Col lg={6} className="mt-3 mt-lg-5">
                      <div className="key-label">Business Name</div>
                      <div className="key-value">{bDetails.business_title}</div>
                    </Col>
                    <Col lg={6} className="mt-3 mt-lg-5">
                      <div className="key-label">Business Phone</div>
                      <div className="key-value">{bDetails.mobile_number}</div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} className="mt-3 mt-lg-5">
                      <div className="key-label">Category</div>
                      <div className="key-value">{bDetails.category_name}</div>
                    </Col>
                    <Col lg={6} className="mt-3 mt-lg-5">
                      <div className="key-label">Description</div>
                      <div className="key-value">{bDetails.description}</div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} className="mt-3 mt-lg-5">
                      <div className="key-label">Service Range</div>
                      <div className="key-value">{bDetails.service_range_km}</div>
                    </Col>
                    <Col lg={6} className="mt-3 mt-lg-5">
                      <div className="key-label">Place</div>
                      <div className="key-value">{bDetails.place}</div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} className="mt-3 mt-lg-5">
                      <div className="key-label">Latitude</div>
                      <div className="key-value">{bDetails.latitude}</div>
                    </Col>
                    <Col lg={6} className="mt-3 mt-lg-5">
                      <div className="key-label">Longitude</div>
                      <div className="key-value">{bDetails.longitude}</div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} className="mt-3 mt-lg-5">
                      <div className="key-label">Service Localities</div>
                      <div className="key-value">{bDetails.service_localities}</div>
                    </Col>
                  </Row>
                  
                </Container>

                {/* Edit Business Details Popup */}
                <Popup
                  contentStyle={{ backgroundColor: "white" }}
                  open={editPopupOpen}
                  onClose={() => setEditPopupOpen(false)}
                  modal
                  nested
                >
                  {(close) => (
                    <div>
                      <div className="close-btn" onClick={close}>
                        <MdClose />
                      </div>
                      <div className="edit-div-subplan">
                        <form onSubmit={handleSubmit}>
                          <h3 className="edit-heading">Edit Business Details</h3>
                          <TextField
                            className="plan-form-textfield"
                            name="business_title"
                            label="Business Name"
                            variant="outlined"
                            size="small"
                            value={editedBusiness.business_title || ""}
                            onChange={handleChangeBusiness}
                          />
                          <TextField
                            className="plan-form-textfield"
                            name="mobile_number"
                            label="Phone Number"
                            variant="outlined"
                            size="small"
                            value={editedBusiness.mobile_number || ""}
                            onChange={handleChangeBusiness}
                            error={!!errors.mobile_number}
                            helperText={errors.mobile_number}
                          />
                          <TextField
                            className="plan-form-textfield"
                            name="description"
                            label="Description"
                            variant="outlined"
                            size="small"
                            multiline
                            rows={4}
                            value={editedBusiness.description || ""}
                            onChange={handleChangeBusiness}
                          />
                          <TextField
                            className="plan-form-textfield"
                            name="service_range_km"
                            label="Service Range (km)"
                            variant="outlined"
                            size="small"
                            value={editedBusiness.service_range_km || ""}
                            onChange={handleChangeBusiness}
                          />
                          <TextField
                            className="plan-form-textfield"
                            name="service_localities"
                            label="Service Localities"
                            variant="outlined"
                            size="small"
                            value={editedBusiness.service_localities || ""}
                            onChange={handleChangeBusiness}
                          />
                          <TextField
                            className="plan-form-textfield"
                            name="place"
                            label="Place"
                            variant="outlined"
                            size="small"
                            value={editedBusiness.place || ""}
                            onChange={handleChangeBusiness}
                          />
                          <TextField
                            className="plan-form-textfield"
                            name="latitude"
                            label="Latitude"
                            variant="outlined"
                            size="small"
                            value={editedBusiness.latitude || ""}
                            onChange={handleChangeBusiness}
                          />
                          <TextField
                            className="plan-form-textfield"
                            name="longitude"
                            label="Longitude"
                            variant="outlined"
                            size="small"
                            value={editedBusiness.longitude || ""}
                            onChange={handleChangeBusiness}
                          />

                          <div className="popup-button text-center">
                            <Button
                            variant="outline-success"
                              type="submit"
                              size="sm"
                              className="popup-save"
                              disabled={loading}
                            >
                              {loading ? "Saving..." : "Save"}
                            </Button>
                            <Button
                              type="button"
                              variant="outline-danger"
                              size="sm"
                              className="popup-cancel mx-2"
                              onClick={close}
                            >
                              Cancel
                            </Button>
                          </div>
                        </form>
                      </div>
                    </div>
                  )}
                </Popup>
              </Card>
            </React.Fragment>
          ))
        )}
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default Settings;
